import React from "react";
import { Box, Chip, IconButton, Switch, Tooltip, Typography, useTheme, } from "@mui/material";
import { Edit } from "iconsax-react";
import TrashIcon from "../icons/TrashIcon";
import { SettingCardWrapper } from "./SettingCardWrapper";
export const SettingRoleCard = ({ row, canUpdate, canDelete, onToggle, onEdit, onDelete, }) => {
    const theme = useTheme();
    return (React.createElement(SettingCardWrapper, null,
        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1 } },
            React.createElement(Tooltip, { arrow: true, title: row.isSystem
                    ? "Systeemrollen kunnen niet worden gewijzigd"
                    : "Status wijzigen" },
                React.createElement("span", null,
                    React.createElement(Switch, { size: "small", checked: row.active, disabled: row.isSystem || !canUpdate, onChange: () => onToggle(row) }))),
            React.createElement(Typography, { variant: "h6", sx: { flex: 1, minWidth: 0 }, noWrap: true }, row.role),
            React.createElement(Box, { sx: { display: "flex", flexShrink: 0 } },
                canUpdate && (React.createElement(Tooltip, { arrow: true, title: row.isSystem
                        ? "Systeemrollen kunnen niet worden bewerkt"
                        : "Rol bewerken" },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", onClick: () => onEdit(row), disabled: row.isSystem, sx: { opacity: row.isSystem ? 0.5 : 1 } },
                            React.createElement(Edit, { variant: "Bulk", size: 20, color: theme.palette.primary.main }))))),
                canDelete && (React.createElement(Tooltip, { arrow: true, title: row.isSystem
                        ? "Systeemrollen kunnen niet worden verwijderd"
                        : "Rol verwijderen" },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", onClick: () => onDelete(row), disabled: row.isSystem, sx: { opacity: row.isSystem ? 0.5 : 1 } },
                            React.createElement(TrashIcon, { size: 20, color: theme.palette.error.main }))))))),
        React.createElement(Box, { sx: { mt: 1.5 } },
            React.createElement(Chip, { label: `${row.users} Gebruikers`, size: "small", sx: {
                    borderRadius: "24px",
                    color: "#54801A",
                    backgroundColor: "#86B84529",
                    fontWeight: 500,
                } }))));
};
